var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_302_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.1864 396.864C65.636 434.565 90.8268 442.412 108.538 434.565C142.791 419.389 231.767 402.432 323.149 442.29C444.179 495.079 469.93 415.434 431.304 334.87C392.677 254.306 379.585 172.834 424.114 127.947C468.643 83.0607 410.372 12.842 306.889 85.9348C240.014 133.17 190.936 122.652 164.581 109.299C139.742 96.714 112.119 83.5572 86.2383 93.83C54.835 106.296 42.4611 133.322 90.2398 193.698C157.946 279.256 15.5541 312.358 50.1864 396.864Z",
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.092 213.21H353.535V398.125C353.535 398.502 353.386 398.863 353.119 399.129C352.853 399.396 352.492 399.545 352.115 399.545H114.512C114.136 399.545 113.774 399.396 113.508 399.129C113.242 398.863 113.092 398.502 113.092 398.125V213.21Z",
    fill: "#A2BDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.216 140.747H181.415L113.092 213.21H353.535L293.216 140.747Z",
    fill: "#418DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.866 111.761L181.415 140.747L113.092 213.21L61.3322 173.873L135.866 111.761Z",
    fill: "#699CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.764 111.761L293.216 140.747L353.535 213.21L413.298 173.873L338.764 111.761Z",
    fill: "#699CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.788 113.243C212.073 112.634 213.073 111.551 213.579 110.222C214.085 108.892 214.057 107.418 213.502 106.109L193.011 57.7924C192.721 57.108 192.295 56.4894 191.76 55.9737C191.225 55.4581 190.59 55.056 189.896 54.7917C189.201 54.5274 188.46 54.4064 187.717 54.4359C186.974 54.4653 186.245 54.6447 185.573 54.9632L181.626 56.835C180.954 57.1535 180.354 57.6045 179.861 58.161C179.368 58.7174 178.993 59.3678 178.757 60.073C178.522 60.7782 178.432 61.5236 178.493 62.2645C178.553 63.0054 178.762 63.7265 179.109 64.3843L203.546 110.829C204.209 112.087 205.332 113.042 206.682 113.492C208.031 113.942 209.502 113.853 210.788 113.243Z",
    fill: "#418DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.477 108.559C237.407 108.493 238.276 108.07 238.902 107.378C239.527 106.686 239.861 105.78 239.834 104.848L238.822 70.4505C238.808 69.9633 238.695 69.484 238.491 69.0415C238.286 68.5989 237.995 68.2023 237.633 67.8753C237.272 67.5484 236.848 67.2979 236.387 67.139C235.926 66.9801 235.438 66.9159 234.952 66.9505L232.094 67.1541C231.608 67.1887 231.134 67.3212 230.7 67.5437C230.267 67.7661 229.883 68.0739 229.571 68.4486C229.26 68.8232 229.027 69.257 228.887 69.7238C228.748 70.1906 228.704 70.6809 228.758 71.1651L232.628 105.359C232.733 106.286 233.192 107.136 233.909 107.733C234.627 108.329 235.547 108.625 236.477 108.559Z",
    fill: "#418DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.309 121.274C258.868 122.754 262.46 121.396 264.452 118.196L299.829 61.3815C301.942 57.9874 301.441 53.8506 298.727 52.2815L294.945 50.0948C292.231 48.5254 288.396 50.155 286.508 53.6797L254.914 112.681C253.135 116.004 253.75 119.795 256.309 121.274Z",
    fill: "#418DF9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_302_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBoxIcon);
export default __webpack_public_path__ + "static/media/empty_box_icon.ce6f1fff3d819fbc2ec395aa21b04bd4.svg";
export { ForwardRef as ReactComponent };